<script>
import { computed } from 'vue';

import useMainState from '@/state/useMainState';
import languages from '@/utils/languages';
import OptionsList from '@/components/OptionsList/OptionsList.vue';

export default {
  components: {
    OptionsList,
  },
  setup() {
    const { language, setLanguage } = useMainState();
    const languageOptions = computed(
      () => languages.map((l) => ({ ...l, active: l.value === language.value })),
    );
    const label = computed(
      () => ((languageOptions.value.filter((i) => i.active) || []).pop() || {}).label,
    );

    return {
      setLanguage,
      languageOptions,
      label,
    };
  },
};
</script>

<template>
  <LpDropdown>
    <template #btn="{ open }">
      <slot
        name="trigger"
        :label="label"
        :open="open"
      />
    </template>
    <template #menu="{ closeMenu }">
      <OptionsList
        data-testid="options"
        :options="languageOptions"
        class="min-w-dropdown-sm"
        @click="async (item) => {
          await setLanguage(item.value);
          closeMenu();
        }"
      />
    </template>
  </LpDropdown>
</template>
